(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ba-hit-player"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const openButton = event.target.closest('[data-ba-hit-open]');
    if (openButton) {
      const card = openButton.closest('[data-ba-hit-card]');
      const dialog = card?.querySelector('dialog');
      const player = dialog?.querySelector('[data-ba-hit-player]');
      const template = card?.querySelector('[data-ba-hit-template]');
      if (!(dialog instanceof HTMLDialogElement) || !(template instanceof HTMLTemplateElement) || !player || dialog.open) return;
      dialog.addEventListener('close', () => player.replaceChildren(), { once: true });
      dialog.showModal();
      player.replaceChildren(template.content.cloneNode(true));
      return;
    }
    const closeButton = event.target.closest('[data-ba-hit-close]');
    if (closeButton) {
      const dialog = closeButton.closest('dialog');
      if (dialog instanceof HTMLDialogElement) dialog.close();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ba-tokyo-product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ba-variant-description')) {
    customElements.define('ba-variant-description', class extends HTMLElement {
      connectedCallback() {
        this.variantIds = (this.dataset.variantIds || '').split(',');
        this.formatIndex = this.dataset.formatOptionIndex === '' ? -1 : Number(this.dataset.formatOptionIndex);
        this.onVariantChange = (event) => {
          const variant = event.detail?.variant;
          if (!variant || !this.variantIds.includes(String(variant.id)) || this.formatIndex < 0) return;
          const value = String(variant.options?.[this.formatIndex] || '').trim().toLowerCase();
          const format = ['løs pakke', 'pakke'].includes(value) ? 'pack'
            : ['hel boks', 'boks', 'hel tin', 'hel case'].includes(value) ? 'box' : '';
          if (!format) return;
          this.dataset.selectedFormat = format;
          this.updateContent(format);
        };
        document.addEventListener('product:variant-change', this.onVariantChange);
        this.updateContent(this.dataset.selectedFormat);
      }

      disconnectedCallback() {
        document.removeEventListener('product:variant-change', this.onVariantChange);
      }

      updateContent(format) {
        this.querySelectorAll('[data-ba-format-content]').forEach((element) => {
          element.hidden = Boolean(format) && element.dataset.baFormatContent !== format;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ba-tokyo-search-links"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    document.querySelectorAll('.ba-tokyo-grading-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ba-tokyo-grading-menu[open]').forEach((menu) => {
      const returnFocus = menu.contains(document.activeElement);
      menu.open = false;
      if (returnFocus) {
        event.preventDefault();
        menu.querySelector('summary').focus();
      }
    });
  });

  document.addEventListener('focusout', (event) => {
    const menu = event.target.closest('.ba-tokyo-grading-menu');
    if (menu && event.relatedTarget && !menu.contains(event.relatedTarget)) menu.open = false;
  });
  } catch(e) { console.error(e); }
})();

})();
